import ApprovalWrapper from "./ApprovalWrapper";

export default ApprovalWrapper;
